import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { MultiInputsControl } from 'partner360/components/multiInputsControl'
import { updateAssortmentItem } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentItem } from 'partner360/features/assortment/models/data/IAssortmentItem'

import { TRANSLATION_KEYS } from '../../../../translations'

import { BREAK_ITEM_KEY } from './configs'

import styles from './MultipleFields.module.scss'

interface IMultipleFieldsProps {
  isEditMode: boolean
  item: IAssortmentItem
  field: 'Configurations' | 'Comments'
  placeholderTranslationKey: string
}

export const MultipleFields: FC<IMultipleFieldsProps> = ({
  isEditMode,
  item,
  field,
  placeholderTranslationKey,
}) => {
  const dispatch = useAppDispatch()
  const translationMode = useSelector(selectTranslationMode)

  const isTranslationMode = translationMode === TranslationMode.Edit

  const values = useMemo(() => {
    const value = item[field]
    if (!value) {
      return ['']
    }

    return value.split(BREAK_ITEM_KEY)
  }, [item, field])

  const handleChange = useCallback(
    (values: string[]) => {
      dispatch(
        updateAssortmentItem({
          ...item,
          [field]: values.join(BREAK_ITEM_KEY),
        })
      )
    },
    [dispatch, item, field]
  )

  if (isEditMode) {
    return (
      <>
        <RenderWhen condition={isTranslationMode}>
          <Translation text={placeholderTranslationKey} span />
        </RenderWhen>
        <MultiInputsControl
          isTextArea
          isTranslatable
          showRowControl
          placeholder={placeholderTranslationKey}
          showBottomControl={false}
          onChange={handleChange}
          values={values}
        />
      </>
    )
  }

  return (
    <ul className={styles.root}>
      {values.map((value, index) => (
        <li key={index}>{value}</li>
      ))}
    </ul>
  )
}
